<script lang="ts">import { cfgToThemeCdnPath, stateTheme } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { loggedIn, toSiteUrl } from "@infinitro/global";
import SocialMedia from "./social-media.svelte";
let copyrightVerbiage = $derived(`${$stateTheme}_all_rights_reserved`);
</script>

<div>
	<div class="footer-badges-social">
		<div class="footer-badges">
			<!-- badges -->
			<a href={`${toSiteUrl('/terms-of-service/', $loggedIn)}#point-18`}>
				<img
					src={cfgToThemeCdnPath(`/footer/a18+.png`)}
					alt={$t(Verbiage.logo_alt, 'alts')}
					style="height:56px"
				/>
			</a>
			{#if $loggedIn}
				<img style="height:37px" src={cfgToThemeCdnPath(`/footer/tr-check.png`)} alt="tr-check" />
			{/if}
			<img style="height:29px" src={cfgToThemeCdnPath(`/footer/GCB.png`)} alt="GCB" />
			<img
				style="height:20px"
				src={cfgToThemeCdnPath(`/footer/gambleaware.png`)}
				alt="gambleaware"
			/>
		</div>
		<div>
			<SocialMedia />
		</div>
	</div>
	{#if $loggedIn}
		<p class="footer-copyright">
			{$t(copyrightVerbiage)}
		</p>
	{/if}
</div>

<style>
	.footer-badges-social {

    display: flex;

    flex-direction: column-reverse;

    gap: 1rem
}

@media (min-width: 768px) {

    .footer-badges-social {

        flex-direction: row;

        align-items: center;

        justify-content: space-between
    }
}

	.footer-badges {

    display: flex;

    flex-wrap: wrap;

    align-items: center;

    justify-content: space-between;

    gap: 0.75rem
}

	@media (min-width: 768px) {

    .footer-badges {

        justify-content: flex-start
    }
}

	.footer-copyright {

    font-size: 0.75rem;

    line-height: 1rem;

    color: var(--color-text-300);

    margin-top: 2rem;

    margin-bottom: 1rem
}
</style>
